import { keys, orderBy, values, filter } from 'lodash';

export function libraryFilters(state) {
  return state.libraryFilters;
}

export function trimmedLibraryFilters(state, getter) {
  return {
    subject_id: state.libraryFilters.subject_id === '0' ? '' : state.libraryFilters.subject_id,
    grade_id: state.libraryFilters.grade_id === '0' ? '' : state.libraryFilters.grade_id,
    unit_id: state.libraryFilters.unit_id === '0' ? '' : state.libraryFilters.unit_id,
    core_concept_id: state.libraryFilters.core_concept_id === '0' ? '' : state.libraryFilters.core_concept_id,
    publisher_id: state.libraryFilters.publisher_id === '0' ? '' : state.libraryFilters.publisher_id,
    chapter_position: getter.currentLibraryChapterPosition,
    media_type: state.libraryFilters.media_type === 'all' ? '' : state.libraryFilters.media_type,
    share_level: state.libraryFilters.share_level,
    order_by: state.libraryFilters.order_by,
    search_keywords: state.libraryFilters.search_keywords,
    offset: state.libraryFilters.offset,
    school_id: state.libraryFilters.school_id,
  };
}

export function myCardsFilters(state) {
  return state.myCardsFilters;
}

export function trimmedMyCardsFilters(state, getter) {
  return {
    subject_id: state.myCardsFilters.subject_id === '0' ? '' : state.myCardsFilters.subject_id,
    grade_id: state.myCardsFilters.grade_id === '0' ? '' : state.myCardsFilters.grade_id,
    unit_id: state.myCardsFilters.unit_id === '0' ? '' : state.myCardsFilters.unit_id,
    core_concept_id: state.myCardsFilters.core_concept_id === '0' ? '' : state.myCardsFilters.core_concept_id,
    chapter_position: getter.currentMyCardsChapterPosition,
    media_type: state.myCardsFilters.media_type === 'all' ? '' : state.myCardsFilters.media_type,
    order_by: state.myCardsFilters.order_by,
    search_keywords: state.myCardsFilters.search_keywords,
    offset: state.myCardsFilters.offset,
    author_id: getter.currentUser.id,
  };
}

export function pageLibraryFilters(state) {
  return state.pageLibraryFilters;
}

export function trimmedPageLibraryFilters(state, getter) {
  return {
    subject_id: state.pageLibraryFilters.subject_id === '0' ? '' : state.pageLibraryFilters.subject_id,
    grade_id: state.pageLibraryFilters.grade_id === '0' ? '' : state.pageLibraryFilters.grade_id,
    unit_id: state.pageLibraryFilters.unit_id === '0' ? '' : state.pageLibraryFilters.unit_id,
    core_concept_id: state.pageLibraryFilters.core_concept_id === '0' ? '' : state.pageLibraryFilters.core_concept_id,
    chapter_position: getter.currentPageLibraryChapterPosition,
    media_type: state.pageLibraryFilters.media_type === 'all' ? '' : state.pageLibraryFilters.media_type,
    is_quiz: state.pageLibraryFilters.is_quiz,
    order_by: state.pageLibraryFilters.order_by,
    search_keywords: state.pageLibraryFilters.search_keywords,
    offset: state.pageLibraryFilters.offset,
  };
}

export function assignmentsFilters(state) {
  return state.assignmentsFilters;
}

export function trimmedAssignmentsFilters(state) {
  return {
    status: state.assignmentsFilters.status === 'all' ? '' : state.assignmentsFilters.status,
    class_id: state.assignmentsFilters.class_id === 'all' ? '' : state.assignmentsFilters.class_id,
    per_page: state.assignmentsFilters.per_page,
    page: state.assignmentsFilters.page,
  };
}

export function subjectMap(state) {
  return state.subjectMap;
}

export function subjectIds(state) {
  return orderBy(keys(state.subjectMap).filter(id => id !== '9999'), parseInt);
}

export function subjectList(state) {
  return [
    { id: '0', name: 'common.selects.all_subjects' },
    ...state.subjectList,
  ];
}

export function gradeMap(state) {
  return state.gradeMap;
}

export function gradeIds(state) {
  return orderBy(keys(state.gradeMap).filter(id => id !== '9999'), parseInt);
}

export function gradeList(state) {
  return orderBy(filter(state.gradeMap, (grade) => {
    if (
      grade.id
      && grade.id !== 0
      && grade.id !== 999
    ) {
      return grade;
    }

    return false;
  }));
}

export function coreConcepts(state) {
  return state.coreConcepts;
}

export function units(state) {
  return state.units;
}

export function coreConceptList(state) {
  return values(state.coreConcepts);
}

export function domainList(state) {
  return values(state.domains);
}

export function unitList(state) {
  return values(state.units);
}

export function gradeSubjects(state) {
  return orderBy(state.gradeSubjects, ['position'], ['asc']) || [];
}



// WEBPACK FOOTER //
// ./src/app/browse-filters/store/getters.js